const STRIP_BEGINNING_AND_END_SLASHES = /^\/|\/$/g

class S3 {
  constructor (options) {
    this.options = options
    this.modes = ['read']
  }

  get name () {
    return `S3 (${this.options.bucket}/${this.key})`
  }

  get key () {
    return (this.options.filename || S3.DEFAULTS.key).replace(STRIP_BEGINNING_AND_END_SLASHES, '')
  }

  // aws-sdk (even scoped to just the S3 client) is the single heaviest
  // dependency in the app -- its request-signing/XML/JMESPath machinery
  // and Node polyfills add up regardless of how few of its services are
  // used. name/modes above don't need it, so it's only fetched over the
  // network, and only parsed, when a fetch actually happens.
  async fetch () {
    const { default: S3Client } = await import('aws-sdk/clients/s3')

    const s3 = new S3Client({
      endpoint: this.options.endpoint || S3.DEFAULTS.endpoint,
      accessKeyId: this.options.accessKeyId,
      secretAccessKey: this.options.secretAccessKey,
      region: this.options.region || S3.DEFAULTS.region,
      apiVersion: 'latest',
      maxRetries: 1
    })

    return new Promise((resolve, reject) => {
      s3.getObject({
        Bucket: this.options.bucket,
        Key: this.key,
        ResponseCacheControl: 'no-cache'
      }, (err, content) => {
        if (!content || !content.Body) {
          return reject(new Error('No data returned'))
        }

        resolve(content.Body.toString())
      })
    })
  }
}

S3.DEFAULTS = {
  endpoint: 's3.us-east-1.amazonaws.com',
  region: 'us-east-1',
  secretAccessKey: '',
  accessKeyId: '',
  bucket: '',
  key: 'accounting.dat'
}

export default S3
